<ng-container>
	<div fxLayout="column" style="padding:16px;">
		<div fxFlex="10" style="padding:16px 16px 0px 16px; color: #ffffff;">
			<div class="card-title" style="font-size: 21px;" translate>ニュース・お知らせ</div>
		</div>
		<mat-card style="margin:42px;">
			<mat-card-header>
				<mat-card-title>{{titlepage}}</mat-card-title>
			</mat-card-header>
			<mat-card-content>
				<div fxLayout="column" fxLayoutAlign="center center" style="height:300px;">
						<app-image [scope]="'publish'" [fileName]="imageName(images, 0)" [type]="imageMedia(images, 0)" style="margin:24px;max-width:300px;max-height: 300px;" ></app-image>
					<!--	<img *ngIf="!(imagePath(images , 0) === '')" [src]="imagePath(images , 0)" style="margin:24px;max-width:300px;max-height: 300px;"> -->
				</div>
				<div [innerHTML]='description' style="font-size: 17px;font-weight:500;line-height: 38px;"></div>
			</mat-card-content>
		</mat-card>
	</div>
</ng-container>
